
export const transliterateGreekToLatin = (text: string): string => {
    const greekToLatinMap: { [key: string]: string } = {
        'α': 'a', 'β': 'v', 'γ': 'g', 'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'i', 'θ': 'th', 'ι': 'i', 'κ': 'k',
        'λ': 'l', 'μ': 'm', 'ν': 'n', 'ξ': 'x', 'ο': 'o', 'π': 'p', 'ρ': 'r', 'σ': 's', 'τ': 't', 'υ': 'y',
        'φ': 'f', 'χ': 'ch', 'ψ': 'ps', 'ω': 'o', 'ς': 's',
        'Α': 'A', 'Β': 'V', 'Γ': 'G', 'Δ': 'D', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'I', 'Θ': 'Th', 'Ι': 'I', 'Κ': 'K',
        'Λ': 'L', 'Μ': 'M', 'Ν': 'N', 'Ξ': 'X', 'Ο': 'O', 'Π': 'P', 'Ρ': 'R', 'Σ': 'S', 'Τ': 'T', 'Υ': 'Y',
        'Φ': 'F', 'Χ': 'Ch', 'Ψ': 'Ps', 'Ω': 'O',
        'ά': 'a', 'έ': 'e', 'ή': 'i', 'ί': 'i', 'ό': 'o', 'ύ': 'y', 'ώ': 'o',
        'Ά': 'A', 'Έ': 'E', 'Ή': 'I', 'Ί': 'I', 'Ό': 'O', 'Ύ': 'Y', 'Ώ': 'O',
        'ϊ': 'i', 'ϋ': 'y', 'ΐ': 'i', 'ΰ': 'y'
    };

    return text.split('').map(char => greekToLatinMap[char] || char).join('');
};

/**
 * Sanitizes a string for use in a file path (Firebase Storage).
 * 1. Transliterates Greek to Latin.
 * 2. Replaces non-alphanumeric characters (except - and _) with _.
 * 3. Collapses multiple underscores.
 */
export const sanitizeForStorage = (text: string): string => {
    const latin = transliterateGreekToLatin(text);
    return latin
        .replace(/[^a-zA-Z0-9-_.]/g, '_') // Allow dots for extensions, but mostly names shouldn't have them
        .replace(/_+/g, '_'); // Collapse underscores
};
